var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkbox-group"},[_c('a-radio-group',{attrs:{"defaultValue":_vm.defaultValue,"options":_vm.rlist},on:{"change":_vm.change}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }